module.exports = __webpack_public_path__ + "static/media/PDF_63.2f17129f.pdf";